export default __webpack_public_path__ + "static/media/tuzla-kart-nedir.0a1f3177.png";